import navBar from '../../shared-components/nav-bar/index.mjs';
import footer from '../../shared-components/custom-footer/index.mjs';
import signUp from '../../shared-components/sign-up/index.mjs';
import carousel from '../../shared-components/pic-carousel/index.mjs';

document.addEventListener('DOMContentLoaded', function () {
  const bubbles = document.querySelectorAll('.subjects li');
  let lastIndex = -1;
  setInterval(() => {
    if (!bubbles.length) return;
    // Remove active from all
    bubbles.forEach((b) => b.classList.remove('active'));
    // Pick a random bubble, not the same as last
    let idx;
    do {
      idx = Math.floor(Math.random() * bubbles.length);
    } while (idx === lastIndex && bubbles.length > 1);
    lastIndex = idx;
    const bubble = bubbles[idx];
    bubble.classList.add('active');
    // Remove after 1s unless hovered
    setTimeout(() => {
      if (!bubble.matches(':hover')) bubble.classList.remove('active');
    }, 1000);
  }, 2000);
});

// ---- About page <-> <sign-up> bridge (no HTML changes) ----

/** Normalize helper */
const toValue = (txt) => txt.trim().toLowerCase();

/** Wait until the custom element is defined & rendered once */
async function getSignUp() {
  await customElements.whenDefined('sign-up');
  const el = document.querySelector('sign-up');
  // Ensure it has rendered; its connectedCallback renders immediately,
  // but raf gives us a safe tick for shadow contents to exist.
  await new Promise((r) => requestAnimationFrame(r));
  return el;
}

/** Click a bubble inside the component (optionally only if not already selected) */
function clickBubble(
  signUp,
  groupSelector,
  value,
  { ensureSelected = false, toggle = false } = {},
) {
  const root = signUp.shadowRoot;
  if (!root) return;

  const btn = root.querySelector(`${groupSelector} [data-value="${value}"]`);
  if (!btn) return;

  const isSelected = btn.classList.contains('selected');

  if (ensureSelected) {
    if (!isSelected) btn.click(); // add but don't remove on repeat
  } else if (toggle) {
    btn.click(); // invert current state
  } else {
    // single-select groups behave fine with a direct click
    btn.click();
  }
}

/** Open the slide-out via the component’s public method */
function openSignUp(signUp) {
  if (typeof signUp.open === 'function') {
    signUp.open();
  } else {
    // fallback: toggle the class in shadow (shouldn't be needed)
    const panel = signUp.shadowRoot?.getElementById('contact-slide-panel');
    panel?.classList.add('open');
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const signUp = await getSignUp();
  if (!signUp) return;

  const root = signUp.shadowRoot;

  // ——— 1) “Sign Up for Lessons!” button in the contact card
  const cardSignupBtn = document.getElementById('contact-card-signup');
  if (cardSignupBtn) {
    cardSignupBtn.addEventListener('click', () => openSignUp(signUp));
  }

  // ——— 2) Instruments & Subjects list -> study bubbles (MULTI-SELECT, additive)
  const instrumentItems = document.querySelectorAll('.subjects ul li');
  instrumentItems.forEach((item) => {
    item.style.cursor = 'pointer';
    item.addEventListener('click', () => {
      const val = toValue(item.textContent);
      // Ensure it is selected (don’t toggle off if clicked twice on the page list)
      clickBubble(signUp, '.study-bubbles', val, { ensureSelected: true });
      openSignUp(signUp);
    });
  });

  // ——— 3) Rates grid -> length & recurrence bubbles (single-select)
  const rateBubbles = document.querySelectorAll('.rate-group p');
  rateBubbles.forEach((p) => {
    p.style.cursor = 'pointer';
    p.addEventListener('click', function () {
      // Example text: "$60 — 30 min"  (em dash or hyphen)
      const txt = this.textContent;
      const match = txt.match(/[-—]\s*(.+)$/);
      if (match) {
        const length = match[1].trim(); // "30 min" | "45 min" | "60 min"
        clickBubble(signUp, '.length-bubbles', length);
      }

      // Determine recurrence from enclosing group header
      const group = this.closest('.rate-group');
      const heading = group?.querySelector('h3')?.textContent || '';
      let recurrence = '';
      if (/weekly/i.test(heading)) recurrence = 'Weekly';
      else if (/single/i.test(heading)) recurrence = 'Single';
      if (recurrence) {
        clickBubble(signUp, '.recurrence-bubbles', recurrence);
      }

      openSignUp(signUp);
    });
  });

  // ——— 4) Day pills -> days bubbles (MULTI-SELECT, toggle)
  const dayPills = document.querySelectorAll('.day-pill');
  dayPills.forEach((pill) => {
    pill.addEventListener('click', function () {
      const dayValue = this.dataset.day; // "Monday", etc.

      // Let the component own the pill’s active state via its mirror.
      // We toggle selection by clicking the shadow bubble; it will mirror .active back to this pill.
      clickBubble(signUp, '.days-bubbles', dayValue, { toggle: true });

      openSignUp(signUp);
    });
  });

  // ——— 5) Keep page toggle opening behavior if user hits the floating tab
  // (Not strictly required; component handles its own toggle, but this is harmless.)
  const toggleBtn = root?.getElementById('contact-slide-toggle');
  toggleBtn?.addEventListener('click', () => openSignUp(signUp));
});
